import { FC } from "react";
import styled from "../../../config/emotion";
import { DivProps } from "../../../globalTypes";

type Props = DivProps & {
  color?: string;
  size?: string;
};

const ColorDot = styled.div<Props>`
  width: ${(props) => props.size ?? "24px"};
  height: ${(props) => props.size ?? "24px"};
  border-radius: 50%;
  border: none;
  background-color: ${(props) => props.color};
`;

export default ColorDot as FC<Props>;
export type ColorDotProps = Props;
